/* eslint-disable no-unused-vars */
import rentalUtilizationService from '../services/rentalutilization.service';

const initialState = { rentalutilization: null };

export const rentalutilization = {
    namespaced: true,
    state: initialState,
    actions: { 
        async getRentalUtilization({ commit }, options) {
            const rentalutilization = await rentalUtilizationService.getRentalUtilization(options);
            commit('getRentalUtilizationSuccess', rentalutilization);
        },
    },
    mutations: {
        getRentalUtilizationSuccess(state, rentalutilization) {
            state.rentalutilization = rentalutilization;
        },
    },
    getters: {
        getRentalUtilizationData(state) {
            return state.rentalutilization?.data;
        },
        getRentalUtilizationMeta(state) {
            return state.rentalutilization?.meta;
        },
        getRentalUtilization(state){
            return state.rentalutilization;
        }
    }
}

